import { WordMat } from '@/common/types/wordMat';
import {
  CopySimpleIcon,
  DotsThreeVerticalIcon,
  PencilSimpleIcon,
  PresentationIcon,
  TrashIcon,
} from '@phosphor-icons/react';
import { Button } from '@shadcn/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@shadcn/components/dropdown-menu';
import { TableCell, TableRow } from '@shadcn/components/table';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface WordMatsTableRowProps {
  wordMat: WordMat;
  onPresent: () => void;
  onCopy: () => void;
  onConfirmDelete: () => void;
}

export default function WordMatsTableRow({
  wordMat,
  onPresent,
  onCopy,
  onConfirmDelete,
}: WordMatsTableRowProps) {
  const navigate = useNavigate();
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  function handleNavigateToWordMat() {
    navigate(`/dashboard/wordmats/${wordMat.id}`);
  }

  return (
    <TableRow className="cursor-pointer" onClick={handleNavigateToWordMat}>
      <TableCell>
        <div className="flex items-center gap-3 font-medium">
          {wordMat.name}
        </div>
      </TableCell>
      <TableCell className="text-neutral-500">
        {dayjs(wordMat.updatedAt).fromNow()}
      </TableCell>
      <TableCell className="flex justify-end">
        <DropdownMenu open={isDropdownOpen} onOpenChange={setDropdownOpen}>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              className="p-1/2"
              onClick={(e) => e.stopPropagation()}
            >
              <DotsThreeVerticalIcon size={24} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent onClick={(e) => e.stopPropagation()}>
            <DropdownMenuLabel>{wordMat.name}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="flex gap-2"
              onClick={() => {
                setDropdownOpen(false);
                onPresent();
              }}
            >
              <PresentationIcon weight="bold" size={16} /> Present
            </DropdownMenuItem>
            <DropdownMenuItem
              className="flex gap-2"
              onClick={() => {
                setDropdownOpen(false);
                onCopy();
              }}
            >
              <CopySimpleIcon weight="bold" size={16} /> Make a copy
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="flex gap-2"
              onClick={() => {
                setDropdownOpen(false);
                handleNavigateToWordMat();
              }}
            >
              <PencilSimpleIcon weight="bold" size={16} /> Edit
            </DropdownMenuItem>
            <DropdownMenuItem
              className="flex gap-2 text-red-600"
              onClick={() => {
                setDropdownOpen(false);
                onConfirmDelete();
              }}
            >
              <TrashIcon weight="bold" size={16} /> Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </TableCell>
    </TableRow>
  );
}
